export const headApi = `https://api.inshabangles.com/inshaApp`;